import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';



import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import 'lightgallery/modules/lg-fullscreen.js';

import lozad from 'lozad';

import './js/components/gallery';
import './js/components/navigation';
import './js/components/homeAnimations';
import './js/components/tourGallery';
import './js/components/heroBackground';
import './js/components/heroSlider';
import './js/components/heroVideo';
import './js/globals';
import './js/contact';


import './js/gutenberg/gutenberg.js';

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

// window.nobserver = lozad('.load-recaptcha', {
//     rootMargin: '200px 0px',
//     loaded: el => {
//         $.getScript("https://www.google.com/recaptcha/api.js?render=" + '6LefMGAqAAAAAFepfyE7JcOMfw5BAQEvxz-JxeAu');
//     }
// });
// window.nobserver.observe();
